@if (!isProd) {
  <div class="env-banner">{{ envName }} ENVIRONMENT</div>
}
<router-outlet></router-outlet>
<app-toast-container />